var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"studio-product-events",class:{ review: _vm.review }},[_c('FullEventsCalendar',{attrs:{"calendarEvents":_vm.product.events,"enableScrollToDay":false}}),_c('div',{staticClass:"row page-bottom-filler"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }